import * as React from "react";
import { useState, useEffect } from "react";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DashboardIcon from "@mui/icons-material/Dashboard";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import ListSubheader from '@mui/material/ListSubheader';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import BookIcon from "@mui/icons-material/Book";
import StarBorder from '@mui/icons-material/StarBorder';
import Settings from '@mui/icons-material/Settings';
import NavigateNext from '@mui/icons-material/NavigateNext';

import People from '@mui/icons-material/People';
import PermMedia from '@mui/icons-material/PermMedia';
import Dns from '@mui/icons-material/Dns';
import Public from '@mui/icons-material/Public';
import { FxmsData } from '../datas/FxData';
import { FxmsContentDashboardDialog, FxWindow } from "../windows/FxWindows";
import { FxResource } from "./../inputs/FxResource";
import { FxmsEvent } from "../actions/FxEvent";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ForumIcon from '@mui/icons-material/Forum';
import CabinIcon from '@mui/icons-material/Cabin';
import BuildIcon from '@mui/icons-material/Build';
import SettingsIcon from '@mui/icons-material/Settings';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SchemaIcon from '@mui/icons-material/Schema';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import StorageIcon from '@mui/icons-material/Storage';
import CellWifiIcon from '@mui/icons-material/CellWifi';
import DateRangeIcon from '@mui/icons-material/DateRange';

function getIcon(name, defIcon) {
  const icons = {
    'InboxIcon': <InboxIcon />
    , 'SendIcon': <SendIcon />
    , 'BookIcon': <BookIcon />
    , 'DraftsIcon': <DraftsIcon />
    , 'People': <People />
    , 'Public': <Public />
    , 'ManageAccountsIcon': <ManageAccountsIcon/> // 관리자
    , 'ForumIcon': <ForumIcon/> // (TISP)커뮤니티
    , 'DateRangeIcon': <DateRangeIcon/> // 운전현황
    , 'BuildIcon': <BuildIcon/> // 설비진단
    , 'SettingsIcon': <SettingsIcon/> // 시스템관리
    , 'LeaderboardIcon': <LeaderboardIcon/> //수요예측
    , 'CompareArrowsIcon': <CompareArrowsIcon/> // 에너지거래
    , 'AccountBalanceWalletIcon': <AccountBalanceWalletIcon/> //거래실적
    , 'SchemaIcon': <SchemaIcon/> // 기준정보
    , 'StorageIcon': <StorageIcon/> // 기본데이터관리
    , 'CellWifiIcon': <CellWifiIcon/> // 시스템관제
  };

  const ret = icons[name];
  return ret ? ret : (defIcon ? icons[defIcon] : icons.Public);
}

export const FxMenuList = (props) => {
  const [menus, setMenus] = React.useState([]);
  const grpCloseRef = React.useRef(null);
  const itemClose = React.useRef(null);

  let menuGroups = [];
  let menuItems = [];

  useEffect(() => {
    // 메뉴 그룹 설정
    const menuList = FxmsData.getMenuList();
    menuGroups = [];
    menuItems = [];

    console.log('*** FxMenuList ***', menuList);

    for (let menuGroup of menuList) {
      if (menuGroup.uiCmptName != "DASHBOARD") {
        const items = [];
        for (let menu of menuGroup.subMenuList) { // 왼쪽 메뉴를 클릭했을 때 나오는 서브메뉴
          const r = <FxListItem key={menu.opId} menu={menu} itemClose={itemClose} />;
          items.push(r);
          menuItems.push(r);
        }
      menuGroups.push(<MenuGroup key={menuGroup.opId} menuGroup={menuGroup} items={items} grpCloseRef={grpCloseRef} />);
      }
    }

    setMenus(menuGroups);

    FxmsEvent.addEventListener("FxMenuList", function (event) {
      console.log('*** FxMenuList *** received event ', event);
    });

  }, []);

  return (
    <List
      // sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
      className="FxMenuList"
      component="nav"
      aria-labelledby="nested-list-subheader"
      // subheader={
      //   <ListSubheader component="div" id="nested-list-subheader" className="FxMenuListSubHeader">
      //     THINGSPIRE
      //   </ListSubheader>
      // }
    >
      {menus}
    </List>
  );
};


const MenuGroup = (props) => {
  const { items, menuGroup, grpCloseRef } = props;
  const [open, setOpen] = React.useState(props.firstOpen);

  console.log("menuGroup IconName : ", menuGroup.iconName);

  const groupClick = () => {
    if (open) {
      setOpen(false);
    } else {

      // 다른 메뉴가 열려 있으면 닫는다.
      if (grpCloseRef.current) {
        grpCloseRef.current();
      }

      // 다른 메뉴가 선택되면 이 메뉴를 닫기위해 설정해 준다.
      grpCloseRef.current = function () {
        setOpen(false);
      }
      setOpen(true);
    }
  };

  return (
    <>
      <ListItemButton onClick={groupClick} className="ItemGroup">
        <ListItemIcon className="ItemGroupIcon">
          {getIcon(menuGroup.iconName, 'InboxIcon')} {/* 왼쪽 메뉴바 아이콘 */}
        </ListItemIcon>
        <ListItemText primary={menuGroup.opTitle} className="ItemGroupText"/>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} > {/* timeout="auto" unmountOnExit> */}
        <List component="div" disablePadding>
          {items}
        </List>
      </Collapse>
    </>
  );
};

const FxListItem = (props) => {
  const { menu, selectedData, itemClose } = props;
  const [open, setOpen] = useState(false);

  const clickItem = (event) => {

    // 다른 메뉴가 열려 있으면 닫는다.
    if (itemClose.current) {
      itemClose.current();
      FxWindow.showNavigator("");
    }

    // 다른 메뉴가 선택되면 이 메뉴를 닫기위해 설정해 준다.
    itemClose.current = function () {
      setOpen(false);
    }

    // 내 화면을 연다.
    setOpen(true);
    FxWindow.showNavigator(menu.menuFullName);
  };

  const closeModal = () => {
    setOpen(false);
  };

  useEffect(() => {
  }, []);

  return (
    <>
      <ListItemButton key={menu.opId} sx={{ pl: 4 }} onClick={clickItem} className={"Item" + (open ? " Opened" : "")}>
        <ListItemIcon className={"ItemIcon" + (open ? " Opened" : "")}>
          <NavigateNext />
        </ListItemIcon>
        <ListItemText primary={menu.opTitle} />
        {open ?
          <KeyboardArrowDown
            sx={{
              transform: 'rotate(-90deg)',
              transition: '0.2s'
            }}
          /> : ""}
      </ListItemButton>

      <FxmsContentDashboardDialog
        open={open}
        closeModal={closeModal}
        dialogTitle={menu.opTitle}
        opObj={menu}
      >
        <FxResource menu={menu} selectedData={selectedData} />
      </FxmsContentDashboardDialog>
    </>
  );
};